// In this price management table, data is stored in react hook form in the following structure
// itemId, ext system id, price band id
// separated by * eg:
// 123*null*null this id is an item default price as there is no ext sys and price band id
// 123*456*789 this id is for an external system and a price band price
// 123*null*789 this id is for a price band default price
// 123*456*null this id is for a ext sys default price
// if a product hasn't got a price for a field, it is stored against an id as an empty string

import { DELIMITER } from './constants';
import { IAggregator } from 'src/types/aggregator.types';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';
import { IItemIdWithPrices } from './types';

// placeholders are used to display the "fallback prices"
export const generatePriceFormDefaults = (
  products: IItemIdWithPrices[],
  priceBands: IPriceBandWithVenues[],
  deliveryAggregators: IAggregator[],
) => {
  const defaults = {};

  products?.forEach((product) => {
    const productDefaultPrice = product.prices.find(
      (price) => price.price_band_id === null && price.external_system_id === null,
    );

    //set product default price
    defaults[`${product.item_id}${DELIMITER}${null}${DELIMITER}${null}`] =
      productDefaultPrice?.value_with_tax.toString() || '';

    priceBands?.forEach(({ priceBandId, name: priceBandName }) => {
      // if not default price band, add default price band price to form state
      if (priceBandName !== 'Default') {
        const productDefaultPricebandPrice = product.prices.find(
          (price) => price.price_band_id === priceBandId && price.external_system_id === null,
        );

        defaults[`${product.item_id}${DELIMITER}null${DELIMITER}${priceBandId}`] =
          productDefaultPricebandPrice?.value_with_tax.toString() || '';
      }

      deliveryAggregators.forEach(({ aggregatorId }) => {
        const externalSystemPrice = product.prices.find(
          (price) => price.external_system_id === aggregatorId && price.price_band_id === priceBandId,
        );

        defaults[`${product.item_id}${DELIMITER}${aggregatorId}${DELIMITER}${priceBandId}`] =
          externalSystemPrice?.value_with_tax.toString() || '';
      });
    });
  });
  return defaults;
};
